import React from "react";
import EnterpriseSSO from "../Security/EnterpriseSSO/EnterpriseSSO";
import { useTitle } from "utils/UseTitle";
import title from "global/constants/TitleConstants";

/**
 * Route shell for Settings → Enterprise SSO. The screen renders its own
 * `SettingsLayout` (as Roles and Teams do) because its primary action belongs
 * in the layout's header slot and depends on the screen's own state.
 */
const EnterpriseSSOPage = () => {
  useTitle(title.ENTERPRISE_SSO);

  return <EnterpriseSSO />;
};

export default EnterpriseSSOPage;
